module.exports = __webpack_public_path__ + "0a79b192605ddc817c44770cc946d56f.MP3";